// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import Rails base
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "jquery";
import "jquery.easing";
import videojs from "video.js";
import flatpickr from "flatpickr";

window.videojs = videojs;

// Require images
const images = require.context("../images", true);

// Require fonts
require.context("../fonts/", true);

// Theme
require.context("../themes", true);

// Import Bootstrap
import "../stylesheets/application";
import "../stylesheets/flatpickr";

// Import SIAP Import
import "./siap_import";

// Require toastr
global.toastr = require("toastr");

// Configure toastr immediately
toastr.options = {
  closeButton: true,
  progressBar: true,
  positionClass: 'toast-top-center',
  timeOut: 5000,
  extendedTimeOut: 1000,
  preventDuplicates: true,
  newestOnTop: true
};

// Require video.js
import AppointmentPlayer from "../js/appointment_player.js";
import KeyIncidentPlayer from "../js/key_incident_player.js";
import ClubAdminObservationPlayer from "../js/club_admin_observation_player.js";
import ClipsPlayer from "../js/clips_player.js";
window.AppointmentPlayer = AppointmentPlayer;
window.KeyIncidentPlayer = KeyIncidentPlayer;
window.ClubAdminObservationPlayer = ClubAdminObservationPlayer;
window.ClipsPlayer = ClipsPlayer;

import Appointment from "../js/appointment.js";

// Start Rails base
Rails.start();
Turbolinks.start();
ActiveStorage.start();

// Import app javascripts
import "../js/analytics.js";
import "../js/direct_uploads.js";
import "../js/user_fixture.js";
import "../js/users.js";
import "../js/fixtures.js";
import "../js/fixtures_filter.js";
import "../js/common.js";
import "../js/horizontal-nav.js";
import "../themes/main/admin/vendors/stacktable/stacktable.js";
import 'fabric';
import "../js/scripts.js";
import "../js/sb-admin-charts.min.js";
import "../js/reports.js";
import "../js/question_reports.js";
import "../js/appointment_report.js";
import "../js/key_incidents.js";
import "../js/video_centre.js";
import "../js/sharing.js";
import "../js/observation_clips.js";
import "../js/playlist_clips.js";
import "../js/playlist_show.js";
import "../js/flatpickr_initializer";
import "../js/fullcalendar";
import "../js/calendar";
import "../js/competitions.js";
import "../js/club_feedback_reports.js";
import "../js/unified_reports_filter.js";
import SiapMonitoring from "../js/siap_monitoring.js";
import "../js/siap_settings.js";
import "../js/siap_lookup.js";
import "../js/async_downloads.js";

import FilterForm from "../js/filter_form.js";
import MarkupPlayer from "../js/markup_player.js";
window.MarkupPlayer = MarkupPlayer;

import Observation from "../js/observation.js";
import EditObservationCompetency from "../js/edit_observation_competency.js";
import Club from "../js/club.js";
import User from "../js/user.js";
import TemporaryLocationDate from "../js/temporary_location_date.js";
import GmapsPlace from "../js/gmaps/place.js";

window.Observation = Observation;
window.EditObservationCompetency = EditObservationCompetency;
window.Club = Club;
window.User = User;
window.TemporaryLocationDate = TemporaryLocationDate;
window.GmapsPlace = GmapsPlace;

// Initialize necessaries behaviours
document.addEventListener("turbolinks:load", () => {
  window.appointment_player = new AppointmentPlayer();
  window.key_incident_player = new KeyIncidentPlayer();
  window.club_admin_observation_player = new ClubAdminObservationPlayer();
  window.appointment = new Appointment();
  window.observation = new Observation();
  window.edit_observation_competency = new EditObservationCompetency();
  window.filter_form = new FilterForm();
  window.club = new Club();
  window.user = new User();
  
  // Initialize SIAP Monitoring if on the monitoring page
  if (document.querySelector('[data-controller="siap-monitoring"]')) {
    if (window.siap_monitoring) {
      window.siap_monitoring.dispose();
    }
    window.siap_monitoring = new SiapMonitoring();
  }
});

document.addEventListener("turbolinks:before-visit", () => {
  window.appointment_player.dispose();
  window.key_incident_player.dispose();
  window.club_admin_observation_player.dispose();
  
  // Clean up SIAP monitoring
  if (window.siap_monitoring) {
    window.siap_monitoring.dispose();
    window.siap_monitoring = null;
  }
});
